import { useEffect } from 'react';
import { useFetch } from 'srcAlias/utils/useFetch';
import { useSelector } from 'react-redux';
import { selectSessionId } from 'srcAlias/client/state/selectors';
import { buildApiCallParams } from 'srcAlias/client/utils/apiCallUtils';
import { createHeaders } from 'srcAlias/utils/headers';

export const useAppDataReviewCall = (setAppDataReviewResponse) => {
  const sessionId = useSelector(selectSessionId);

  const { finalUri, method, headersDetails, timeoutOptions } =
    buildApiCallParams({
      apiEndpointEnvVar: 'REACT_APP_APP_DATA_REVIEW_URL',
      mockApiEndpoint: 'api/v0/application-data-review',
      sessionId,
    });

  // eslint-disable-next-line no-console
  console.log(`Making API call to ${finalUri} with method ${method}`);
  const { data, error } = useFetch({
    uri: finalUri,
    fetchOptions: {
      method,
      headers: () => {
        return createHeaders(headersDetails);
      },
    },
    timeoutOptions,
  });

  useEffect(() => {
    setAppDataReviewResponse({ data, error });
  }, [data, error]);
};

export default useAppDataReviewCall;
